import { adminCall, adminGet } from './adminCall';

export async function adminListSmsLogs(params = {}) {
  const qs = new URLSearchParams();
  if (params.companyId) qs.set('companyId', params.companyId);
  if (params.startDate) qs.set('startDate', params.startDate);
  if (params.endDate) qs.set('endDate', params.endDate);
  if (params.success === true || params.success === false) qs.set('success', String(params.success));
  if (params.limit != null) qs.set('limit', String(params.limit));
  if (params.lastDocId) qs.set('lastDocId', params.lastDocId);
  const suffix = qs.toString() ? `?${qs.toString()}` : '';
  return adminGet(`/api/admin/sms-logs${suffix}`);
}
